(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-common-issues"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.common-issues-filter-chips .filter-chip');
    if (!chip) return;

    var group = chip.closest('.common-issues-filter-chips');
    var strip = chip.closest('.common-issues-highlight');
    if (!group || !strip) return;

    group.querySelectorAll('.filter-chip').forEach(function (c) {
      c.classList.toggle('is-active', c === chip);
    });

    var activeTag = chip.dataset.tag;

    var visibleCount = 0;
    strip.querySelectorAll('.grid .item').forEach(function (item) {
      var show = !activeTag || (' ' + (item.dataset.tags || '') + ' ').indexOf(' ' + activeTag + ' ') !== -1;
      item.hidden = !show;
      if (show) visibleCount++;
    });

    var emptyState = strip.querySelector('.common-issues-empty');
    if (emptyState) emptyState.hidden = visibleCount > 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  function fetchAndSwapBlogIndex(url, sectionId, scrollToSectionTop) {
    var section = document.getElementById('blog-index-section');
    if (!section) return;

    var fetchUrl = url;
    if (sectionId) {
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      fetchUrl = url + sep + 'section_id=' + encodeURIComponent(sectionId);
    }
    section.classList.add('is-loading');

    fetch(fetchUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('bad response');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newSection = doc.getElementById('blog-index-section');
        if (!newSection) throw new Error('section not found in response');
        section.replaceWith(newSection);
        if (scrollToSectionTop) {
          newSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function (err) {
        console.warn('[blog-index] fetch failed, falling back to full navigation:', err);
        window.location.href = url;
      })
      .finally(function () {
        try {
          history.pushState({}, '', url);
        } catch (err) {
          console.warn('[blog-index] pushState failed (non-fatal):', err);
        }
      });
  }

  document.addEventListener('click', function (e) {
    var chipLink = e.target.closest('.blog-index .filter-chip');
    var pageLink = e.target.closest('.blog-index .pagination-wrap a');
    var link = chipLink || pageLink;
    if (!link) return;
    e.preventDefault();

    var section = document.getElementById('blog-index-section');
    var sectionId = section && section.dataset.sectionId;
    if (!sectionId) return;

    fetchAndSwapBlogIndex(link.getAttribute('href'), sectionId, !!pageLink);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.blog-search');
    if (!form) return;
    e.preventDefault();

    var query = form.querySelector('input[name="q"]').value.trim();
    var url = form.getAttribute('action') + '?type=article&q=' + encodeURIComponent(query);

    fetchAndSwapBlogIndex(url);
  });

  window.addEventListener('popstate', function () {
    window.location.reload();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-top-repaired"]) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fillBar(el) {
      var target = el.getAttribute('data-fill-to');
      if (!target) return;
      el.style.width = target + '%';
    }

    var fills = document.querySelectorAll('.appliance-common-repairs .repair-bar-fill[data-fill-to]');
    if (!fills.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      fills.forEach(fillBar);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var fillEl = entry.target.querySelector('.repair-bar-fill[data-fill-to]');
            if (fillEl) fillBar(fillEl);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    fills.forEach(function (fillEl) {
      var track = fillEl.closest('.repair-bar');
      observer.observe(track || fillEl);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var hamburger = document.querySelector('.hamburger');
    var mobileNav = document.getElementById('site-nav-mobile');

    // ── Mobile hamburger ──
    if (hamburger && mobileNav) {
      hamburger.addEventListener('click', function () {
        var isOpen = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!isOpen));
        mobileNav.hidden = isOpen;
        this.setAttribute('aria-label', isOpen ? this.dataset.labelOpen : this.dataset.labelClose);
      });

      window.matchMedia('(min-width: 1000px)').addEventListener('change', function (e) {
        if (e.matches) {
          mobileNav.hidden = true;
          hamburger.setAttribute('aria-expanded', 'false');
        }
      });

      mobileNav.querySelectorAll('.mobile-link, .mobile-sublink, .mobile-grandlink, .mobile-cta').forEach(function (link) {
        link.addEventListener('click', function () {
          mobileNav.hidden = true;
          hamburger.setAttribute('aria-expanded', 'false');
        });
      });
    }

    // ── Generic accordion toggle ──
    // Works for both level-2 (.mobile-toggle) and level-3 (.mobile-subtoggle)
    // by finding the nearest <li> ancestor and toggling its first <ul> child.
    function wireAccordionToggles(selector) {
      document.querySelectorAll(selector).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var isOpen = this.getAttribute('aria-expanded') === 'true';
          var li = this.closest('li');
          var submenu = li && li.querySelector('ul');
          if (!submenu) return;
          this.setAttribute('aria-expanded', String(!isOpen));
          submenu.hidden = isOpen;
        });
      });
    }

    wireAccordionToggles('.mobile-toggle');
    wireAccordionToggles('.mobile-subtoggle');

    // ── Desktop dropdown/flyout: click-to-open on the arrow ──
    // Hover/focus-within still opens these via pure CSS for mouse/keyboard
    // users - this is purely for touch, where hover never fires and the
    // arrow is the only thing that should open the submenu (the label text
    // next to it still navigates straight to the parent page as normal).
    function wireDesktopToggle(toggleSelector, itemSelector) {
      document.querySelectorAll(toggleSelector).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var item = this.closest(itemSelector);
          if (!item) return;

          var isOpen = item.classList.contains('is-open');

          // Only one open at a time among siblings at this level.
          var parentList = item.parentElement;
          if (parentList) {
            parentList.querySelectorAll(':scope > ' + itemSelector + '.is-open').forEach(function (sibling) {
              if (sibling === item) return;
              sibling.classList.remove('is-open');
              var siblingToggle = sibling.querySelector(toggleSelector);
              if (siblingToggle) siblingToggle.setAttribute('aria-expanded', 'false');
            });
          }

          item.classList.toggle('is-open', !isOpen);
          this.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    }

    wireDesktopToggle('.nav-toggle', '.nav-item--has-dropdown');
    wireDesktopToggle('.flyout-toggle', '.dropdown-item--has-flyout');

    // ── Desktop dropdown/flyout: Escape + outside-click ──
    document.querySelectorAll('.nav-item--has-dropdown, .dropdown-item--has-flyout').forEach(function (item) {
      var toggle = item.querySelector(':scope > .nav-toggle, :scope > .flyout-toggle');

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          item.classList.remove('is-open');
          if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
        }
      });

      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) {
          item.classList.remove('is-open');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav-item--has-dropdown')) {
        document.querySelectorAll('.nav-item--has-dropdown.is-open, .dropdown-item--has-flyout.is-open').forEach(function (item) {
          item.classList.remove('is-open');
          var toggle = item.querySelector(':scope > .nav-toggle, :scope > .flyout-toggle');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["location-reviews"]) return;
  try {
    
  (function () {
    function debounce(fn, delay) {
      var timer = null;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(fn, delay);
      };
    }

    document.querySelectorAll('.reviews-carousel').forEach(function (carousel) {
      var track = carousel.querySelector('.reviews-track');
      var prevBtn = carousel.querySelector('.reviews-nav--prev');
      var nextBtn = carousel.querySelector('.reviews-nav--next');
      var status = carousel.querySelector('.reviews-status');
      var cards = track ? Array.from(track.querySelectorAll('.card')) : [];
      if (!track || !prevBtn || !nextBtn || !cards.length) return;

      function cardStep() {
        var gap = parseFloat(getComputedStyle(track).columnGap || '0');
        return cards[0].getBoundingClientRect().width + gap;
      }

      function updateNavState() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;
      }

      function announcePosition() {
        if (!status) return;
        var index = Math.round(track.scrollLeft / cardStep());
        index = Math.max(0, Math.min(index, cards.length - 1));
        status.textContent = 'Review ' + (index + 1) + ' of ' + cards.length;
      }

      var debouncedUpdate = debounce(function () {
        updateNavState();
        announcePosition();
      }, 120);

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', debouncedUpdate);
      window.addEventListener('resize', debouncedUpdate);
      updateNavState();
      announcePosition();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-metaobject-province"]) return;
  try {
    
  document.addEventListener('click', async function (event) {
    var link = event.target.closest('.province-cities .pagination-wrap a');
    if (!link) return;

    event.preventDefault();

    var sectionEl = link.closest('[data-section-id]');
    if (!sectionEl) return;

    var sectionId = sectionEl.getAttribute('data-section-id');
    var url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    sectionEl.setAttribute('aria-busy', 'true');

    try {
      var response = await fetch(url.toString());
      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newSection = doc.querySelector('[data-section-id="' + sectionId + '"]');

      if (newSection) {
        sectionEl.replaceWith(newSection);
        history.pushState({}, '', link.href);

        var heading = newSection.querySelector('.province-cities .section-heading');
        if (heading) {
          heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } else {
        window.location.href = link.href;
      }
    } catch (err) {
      window.location.href = link.href;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function debounce(fn, delay) {
      var timer = null;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(fn, delay);
      };
    }

    document.querySelectorAll('.reviews-carousel').forEach(function (carousel) {
      var track = carousel.querySelector('.reviews-track');
      var prevBtn = carousel.querySelector('.reviews-nav--prev');
      var nextBtn = carousel.querySelector('.reviews-nav--next');
      var status = carousel.querySelector('.reviews-status');
      var cards = track ? Array.from(track.querySelectorAll('.card')) : [];
      if (!track || !prevBtn || !nextBtn || !cards.length) return;

      function cardStep() {
        var gap = parseFloat(getComputedStyle(track).columnGap || '0');
        return cards[0].getBoundingClientRect().width + gap;
      }

      function updateNavState() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;
      }

      function announcePosition() {
        if (!status) return;
        var index = Math.round(track.scrollLeft / cardStep());
        index = Math.max(0, Math.min(index, cards.length - 1));
        status.textContent = 'Review ' + (index + 1) + ' of ' + cards.length;
      }

      var debouncedUpdate = debounce(function () {
        updateNavState();
        announcePosition();
      }, 120);

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', debouncedUpdate);
      window.addEventListener('resize', debouncedUpdate);
      updateNavState();
      announcePosition();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
